export const isHtmlButtonRef = (
  ref: React.RefObject<HTMLButtonElement | null>,
): ref is React.RefObject<HTMLButtonElement> => ref.current !== null;
